module.exports = {"540329100":"孜托镇","540329101":"硕督镇","540329111":"康沙镇","540329112":"马利镇","540329200":"达龙乡","540329201":"新荣乡","540329202":"白达乡","540329203":"玉西乡","540329204":"腊久乡","540329205":"俄西乡","540329206":"中亦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540329.json
// module id = 2714
// module chunks = 0